import { useTranslation } from "react-i18next";
const FilterFunny = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="main__content display_v1" id="main__content__v1">
        {/* 이미지 1장 */}
        <div className="item2">
          <div id="filter__funny_text">
            <div id="filter__funny_title">
              {t("filter__funny_title_1")}
              <br />
              {t("filter__funny_title_2")}
            </div>
            <div className=" text__content" id="filter__funny_content">
              <p>
                {t("filter__funny_content_1")}
                <br /> {t("filter__funny_content_2")}
              </p>
            </div>
          </div>
        </div>
        {/* 모델 상상 그 이상 */}
        <div className="item4">
          <div id="filter__funny_photo">
            <img id="img__filter_funny" src="/assets/images/Filter1.svg" />
          </div>
        </div>
      </div>

      <div className="main__content  display_v2" id="main__content__v1">
        {/* 이미지 1장 */}
        <div className="item2">
          <div id="filter__funny_photo">
            <img id="img__filter_funny" src="/assets/images/Filter1.svg" />
          </div>
        </div>
        {/* 모델 상상 그 이상 */}
        <div className="item4">
          <div id="filter__funny_text">
            <div id="filter__funny_title">
              {t("filter__funny_title_1")}
              <br />
              {t("filter__funny_title_2")}
            </div>
            <div className=" text__content" id="filter__funny_content">
              <p>
                {t("filter__funny_content_1")}
                <br /> {t("filter__funny_content_2")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FilterFunny;
